import { JsonClassDiscriminator3irfencugy52m as JsonClassDiscriminator } from '../JsonAnnotations.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  ENUMlmq49cvwy4ow as ENUM,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance2svuvlggsd3b as ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance } from '../JsonConfiguration.mjs';
import { JsonEncodingException1thxguokvyir3 as JsonEncodingException } from './JsonExceptions.mjs';
import { getJsonEncodedNames32epqb27gispq as getJsonEncodedNames } from './JsonNamesMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function classDiscriminator(_this__u8e3s4, json) {
  var _iterator__ex2g4s = _this__u8e3s4.l1p().p1();
  while (_iterator__ex2g4s.q1()) {
    var annotation = _iterator__ex2g4s.r1();
    if (annotation instanceof JsonClassDiscriminator())
      return annotation.i2t_1;
  }
  return json.f2m_1.z2n_1;
}
function access$checkEncodingConflicts$tPolymorphicKt($receiver, serializer, actualSerializer, classDiscriminator) {
  return checkEncodingConflicts($receiver, serializer, actualSerializer, classDiscriminator);
}
function checkKind(kind) {
  if (kind instanceof ENUM()) {
    // Inline function 'kotlin.error' call
    var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException().o(toString(message));
  }
  if (kind instanceof PrimitiveKind()) {
    // Inline function 'kotlin.error' call
    var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException().o(toString(message_0));
  }
  if (kind instanceof PolymorphicKind()) {
    // Inline function 'kotlin.error' call
    var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
    throw IllegalStateException().o(toString(message_1));
  }
}
function checkEncodingConflicts(_this__u8e3s4, serializer, actualSerializer, classDiscriminator) {
  if (getJsonEncodedNames(actualSerializer.m1m(), _this__u8e3s4).t2(classDiscriminator)) {
    var baseName = serializer.m1m().p1n();
    var actualName = actualSerializer.m1m().p1n();
    var text = _this__u8e3s4.f2m_1.g2o_1.equals(ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance()) && baseName === actualName ? 'in ALL_JSON_OBJECTS class discriminator mode' : "as base class '" + baseName + "'";
    throw JsonEncodingException().v2r("Class '" + actualName + "' cannot be serialized " + text + ' because' + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, or rename property with @SerialName annotation.');
  }
}
//region block: exports
export {
  access$checkEncodingConflicts$tPolymorphicKt as access$checkEncodingConflicts$tPolymorphicKt2migrcemidykb,
  checkKind as checkKind2e7hdnuk9c0tp,
  classDiscriminator as classDiscriminator9fd3hvqsgfqq,
};
//endregion

//# sourceMappingURL=Polymorphic.mjs.map
